import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthModule } from './auth/auth.module';
import { MainModule } from './main/main.module';
import { UserModule } from './user/user.module';
import { UsersModule } from './users/users.module';
import { CompaniesModule } from './companies/companies.module';
import { WorkShiftsModule } from './work-shifts/work-shifts.module';
import { WorkShiftModule } from './work-shift/work-shift.module';
import { SectorsModule } from './sectors/sectors.module';
import { TicketsModule } from './tickets/tickets.module';
import { PagesServicesModule } from './pages-services/pages-services.module';
import { NotificationsModule } from './notifications/notifications.module';
import { WorkShiftExpandedModule } from './work-shift/work-shift-expanded.module';
import { EsasSocketModule } from './esas-socket/esas-socket.module';
import { ReferencesModule } from './references/references.module';
import { AppSettingsModule } from './app-settings/app-settings.module';
import { CheckListsModule } from './check-lists-page/modules/check-lists/check-lists.module';
import { CheckListsPageModule } from './check-lists-page/check-lists-page.module';
import { NormativesModule } from './normatives/normatives.module';

@NgModule({
  imports: [
    CommonModule,
    AuthModule,
    MainModule,
    UserModule,
    UsersModule,
    CompaniesModule,
    WorkShiftsModule,
    WorkShiftModule,
    SectorsModule,
    TicketsModule,
    NotificationsModule,
    PagesServicesModule,
    WorkShiftExpandedModule,
    EsasSocketModule,
    ReferencesModule,
    AppSettingsModule,
    CheckListsPageModule,
    NormativesModule,
  ],
  exports: [
    AuthModule,
    MainModule,
    UserModule,
    UsersModule,
    CompaniesModule,
    WorkShiftsModule,
    WorkShiftModule,
    SectorsModule,
    TicketsModule,
    NotificationsModule,
    PagesServicesModule,
    WorkShiftExpandedModule,
    EsasSocketModule,
    ReferencesModule,
    AppSettingsModule,
    CheckListsModule,
    NormativesModule,
  ],
})
export class PagesModule {}
